module.exports = __webpack_public_path__ + "static/media/ex.82d03513.jpg";